import { actionCopyIt } from "./actionCopy";

export const authCopyIt = {
    backToWebsite: "Tornare al sito web",
    languageLabel: "Language / Sprache / Sprog / Lingua",
    languageDescription:
        "Change the app language. Sprache der App ändern. Skift appsprog. Cambi la lingua dell'applicazione.",
    chooseLanguage: "Scegliere la lingua",
    or: "OPPURE",
    next: actionCopyIt.next,
    submit: actionCopyIt.submit,
    continue: actionCopyIt.continue,
    logout: "Disconnettersi",
    verifyingAuthentication: "Verifica dell'autenticazione...",
    signUpSignIn: "Registrazione / Accesso",
    signIn: "Accedere",
    signUp: "Registrarsi",
    signUpWith: (name) => `Registrarsi con ${name}`,
    alreadyHaveAccount: "Ha già un account?",
    dontHaveAccount: "Non ha un account?",
    signInWithPasswordInstead: "Accedere con una password",
    contactMethodLabel: "Mezzo di contatto",
    patientRole: "Paziente",
    forgotPassword: "Password dimenticata",
    confirmYourAccount: "Confermi il Suo account",
    choosePassword: "Scegliere una password",
    confirmPassword: "Confermare la password",
    showPassword: "Mostrare la password",
    passwordsDontMatch: "Le password non coincidono",
    passwordsMatch: "Le password coincidono",
    passwordAllGood: "Perfetto!",
    passwordRequirementMinLength: "Deve contenere almeno 8 caratteri",
    passwordRequirementLowercase: "Deve contenere una lettera minuscola",
    passwordRequirementUppercase: "Deve contenere una lettera maiuscola",
    passwordRequirementNumber: "Deve contenere un numero",
    passwordRequirementSpecial: "Deve contenere un carattere speciale",
    setYourPassword: "Definisca la Sua password",
    setPasswordDescription: "Crei una password sicura per il Suo account",
    settingPassword: "Impostazione della password...",
    smartAuthHint:
        "Inserisca l'indirizzo e-mail o il numero di telefono a cui è stato inviato il Suo invito Patient Watch.",
    usePhoneInstead: "Usare il telefono",
    useEmailInstead: "Usare l'e-mail",
    phoneVerificationHint: "Invieremo un codice di verifica sul Suo telefono.",
    phoneSignupHint:
        "Invieremo un codice di verifica sul Suo telefono. Potrebbero applicarsi le tariffe standard per i messaggi.",
    loggingIn: "Accesso...",
    sendingCode: "Invio del codice...",
    logIn: "Accedere",
    sendCode: "Inviare il codice",
    sendVerificationCode: "Inviare il codice di verifica",
    sendingCodeEllipsis: "Invio del codice…",
    codeSent: "Codice inviato",
    codeSentToPhone: "Codice inviato sul Suo telefono",
    verificationCodeSent: "Codice di verifica inviato",
    emailFallbackCodeSent: "Non è stato possibile inviare un SMS, pertanto Le abbiamo inviato un codice via e-mail.",
    checkFormAndTryAgain: "Verifichi il modulo e riprovi.",
    somethingWentWrong: "Si è verificato un errore. La preghiamo di riprovare.",
    newUser: "Nuovo utente",
    invitationFound: "Invito trovato",
    accountFound: "Account trovato",
    accountFoundUseEmailSmsNotReady:
        "Account trovato. Acceda con la Sua e-mail. L'accesso via SMS non è ancora configurato per questo numero sul Suo account.",
    smsLoginContactCareTeam:
        "L'accesso via SMS non è disponibile per questo numero. Si rivolga al team che Le ha inviato l'invito per assistenza.",
    authMethodError: "Errore del metodo di autenticazione",
    smsLoginUnavailable:
        "L'accesso via SMS non è ancora disponibile per questo numero. Acceda invece con l'e-mail del Suo account.",
    email: "E-mail",
    emailTab: "E-mail",
    phoneTab: "Telefono",
    emailPlaceholder: "ad es. nome@azienda.com",
    password: "Password",
    phone: "Numero di telefono",
    enterEmailAddress: "Inserisca il Suo indirizzo e-mail",
    enterPhoneNumber: "Inserisca il Suo numero di telefono",
    enterPhoneWithCountryCode: "Inserisca un numero di telefono con il prefisso internazionale.",
    forgotPasswordEmailHint:
        "Inserisca l'indirizzo e-mail del Suo account. Le invieremo un codice di verifica per reimpostare la password.",
    forgotPasswordPhoneHint:
        "Inserisca il numero di telefono del Suo account. Invieremo un codice di verifica via SMS.",
    sending: "Invio...",
    backToSignIn: "Tornare all'accesso",
    backToForgotPassword: "Tornare a « Password dimenticata »",
    backToConfirmAccount: "Tornare alla conferma dell'account",
    backToSignup: "Tornare alla registrazione",
    verifyYourAccount: "Verifichi il Suo account",
    verifyEmailCodeHint: "Inserisca il codice di verifica inviato al Suo indirizzo e-mail.",
    verifySmsCodeHint: "Inserisca il codice inviato al Suo numero di telefono.",
    verifying: "Verifica…",
    resendCode: "Inviare di nuovo il codice",
    didNotReceiveCode: "Non ha ricevuto un codice?",
    resendConfirmationCode: "Inviare di nuovo il codice di conferma",
    needHelpContact: "Serve aiuto? Contatti",
    consentTermsPrefix: "Accetto le",
    termsOfUse: "Condizioni d'uso",
    consentAnd: "e la",
    privacyPolicy: "Politica sulla privacy",
    selectHospitalLabel: "In quale ospedale è seguita per queste cure?",
    selectHospitalPlaceholder: "Selezioni il Suo ospedale",
    selectHospitalToContinue: "Selezioni il Suo ospedale per continuare.",
    studyClinicianSignupHint: "Crei il Suo account clinico. Potrà aggiungere la Sua organizzazione in seguito.",
    studyClinicianSignupHintWithOrganisation:
        "Crei il Suo account clinico. La Sua organizzazione è già definita a partire dall'invito allo studio.",
    ownOrganisationNameLabel: "Nome dell'organizzazione",
    ownOrganisationNamePlaceholder: "ad es. Clinica ortopedica della città",
    ownOrganisationNameHint:
        "In questo modo crea la Sua organizzazione su Patient Watch. Potrà invitare i Suoi colleghi in seguito.",
    organisationNameTooShort: "Inserisca un nome di organizzazione di almeno 3 caratteri.",
    signupSessionExpired: "La Sua sessione di registrazione è scaduta. Torni indietro e richieda un nuovo codice.",
    loadingSignup: "Caricamento della registrazione…",
    welcomeToPatientWatch: "Benvenuta su Patient Watch",
    invitedByLine: (name) => `${name} La ha invitata a unirsi a Patient Watch.`,
    welcomeFirstTime: "Benvenuta - sembra che sia la Sua prima visita.",
    choosePasswordDescription: "Scelga una password per completare la configurazione del Suo account.",
    alreadyHavePasswordSkip: "Saltare - ho già una password",
    finishProfileSetup: "Completiamo la configurazione del Suo profilo.",
    continueToProfileSetup: "Continuare verso la configurazione del profilo",
    alreadySignedIn: "Già connessa",
    alreadySignedInDescription:
        "Continui verso l'applicazione, oppure si disconnetta se ha bisogno di un altro account (ad esempio per aprire un invito o un link di registrazione mentre è già connessa).",
    continueToProfile: "Continuare",
    continueToApp: "Continuare",
    notLoggedInResetPassword: "Non è connessa. Per reimpostare la Sua password, vada a:",
    authenticationComplete: "Autenticazione riuscita",
    authenticationCompleteDescription: "Ora è connessa, faccia clic su Avanti per continuare.",
    authenticationFailed: "Autenticazione non riuscita",
    authenticationFailedDescription: "Link non valido, La preghiamo di riprovare.",
    noAccountFound: "Nessun account trovato",
    noAccountForContact: (contact) => `Nessun account per ${contact}`,
    noAccountForDetails: "Non abbiamo trovato alcun account corrispondente a questi dati.",
    inviteOnlyPlatform: "Patient Watch è una piattaforma solo su invito. Selezioni il Suo ruolo per continuare:",
    iAmPatient: "Sono un paziente",
    iAmClinician: "Sono un clinico",
    wrongEmailGoBack: "Ha indicato un indirizzo e-mail errato?",
    goBackAndTryAgain: "Torni indietro e riprovi.",
    noAccountChoosePath:
        "Se è un clinico, può iniziare gratuitamente subito. Se è un paziente, ha bisogno di un invito.",
    noAccountPatientTitle: "Pazienti",
    noAccountPatientDescription:
        "Patient Watch è riservato ai pazienti invitati. Chieda al Suo ambulatorio di invitarla, oppure chieda assistenza se ritiene di aver già ricevuto un invito.",
    noAccountPatientCta: "Ho bisogno di aiuto (paziente)",
    noAccountClinicianTitle: "Clinici",
    noAccountClinicianDescription:
        "Inviti pazienti, raccolga punteggi di esito e ne segua l'evoluzione - gratuito per iniziare, senza carta di credito. Passi a un piano superiore solo quando la Sua casistica aumenta.",
    noAccountClinicianCta: "Creare un account gratuito",
    confirmAccountInviteTitle: "È invitata a unirsi a Patient Watch",
    couldNotVerifyContact: "Non è stato possibile verificare i Suoi recapiti",
    invitedToJoin: "È invitata a unirsi a Patient Watch",
    inviterInvitedYou: (name) => `${name} La ha invitata.`,
    confirmPhoneInviteBody:
        "Confermi il Suo numero di telefono qui sotto. Le invieremo un codice di verifica via SMS affinché possa completare la configurazione del Suo account.",
    confirmEmailInviteBody:
        "Confermi il Suo indirizzo e-mail qui sotto. Le invieremo un codice di verifica affinché possa completare la configurazione del Suo account.",
    useInvitationContactDetails: "Usare i recapiti del Suo invito",
    enterInvitationContactHint:
        "Inserisca l'indirizzo e-mail o il numero di telefono a cui è stato inviato il Suo invito Patient Watch.",
    enterConfirmationCode: "Inserisca il codice di conferma",
    processing: "Elaborazione in corso",
    verifyYourEmailTitle: "Verifichi il Suo indirizzo e-mail",
    verifyEmailIcon: "Verifichi il Suo indirizzo e-mail",
    emailConfirmed: "Indirizzo e-mail confermato",
    emailConfirmedDescription: "Ora può accedere.",
    verifyEmailWelcome: (firstName) =>
        `Benvenuta${firstName ? `, ${firstName}` : ""}! Dobbiamo verificare il Suo indirizzo e-mail.`,
    verifyEmailSendHint: "Invieremo un codice di verifica di 6 cifre a questo indirizzo e-mail.",
    sendingCodeButton: "Invio del codice...",
    sendVerificationCodeButton: "Inviare il codice di verifica",
    enterVerificationCode: "Inserisca il codice di verifica",
    enterCodeSentTo: (email) => `Inserisca il codice inviato a ${email}`,
    checkJunkFolder: "Non dimentichi di controllare la cartella della posta indesiderata.",
    deleteAccount: "Eliminare l'account",
    deleteAccountReason: "Motivo dell'eliminazione dell'account",
    troubleAccessingTitle: "Difficoltà ad accedere a Patient Watch?",
    patientInviteMismatch: (email) =>
        `Se ha ricevuto un invito, verifichi che l'indirizzo e-mail invitato sia proprio ${email}.`,
    patientContactProvider:
        "Se ritiene che avrebbe dovuto ricevere un invito, contatti il Suo fornitore di assistenza per confermare i Suoi recapiti.",
    contactSupportTeam: "Contattare il nostro team di assistenza",
    interestedInPwTitle: "Interessata a Patient Watch?",
    interestedInPwBody1:
        "Patient Watch La aiuta a monitorare gli esiti dei Suoi pazienti e a restare in contatto con il Suo ambulatorio. Iniziare è rapido e semplice - può essere operativa in pochi minuti.",
    interestedInPwBody2:
        "Inizi con un account gratuito - 5 nuovi diari per periodo di fatturazione, senza carta di credito. Passi al piano Starter o Pro quando ha bisogno di maggiore capacità. I piani a pagamento includono una garanzia di rimborso di 30 giorni se non fanno al caso Suo.",
    signupStarterPlan: "Vedere i piani a pagamento",
    carePlanInjection: "Il Suo piano di cura comprende un'iniezione.",
    carePlanInjectionTo: (where, substance, amount) => {
        if (where && substance && amount) return `Iniezione in ${where}: ${substance} (${amount}).`;
        if (where && substance) return `Iniezione in ${where}: ${substance}.`;
        if (where && amount) return `Iniezione in ${where} (${amount}).`;
        if (where) return `Monitoraggio dopo un'iniezione in ${where}.`;
        if (substance && amount) return `Iniezione: ${substance} (${amount}).`;
        if (substance) return `Iniezione: ${substance}.`;
        return "";
    },
    carePlanSurgery: "Il Suo piano di cura comprende un'operazione.",
    carePlanSurgeryArea: (area) => `Il Suo piano di cura comprende un'operazione (${area}).`,
    carePlanShockwave: "Il Suo piano di cura comprende un trattamento con onde d'urto.",
    authErrorTitle: "Errore di autenticazione",
    almostThere: "Quasi terminato.",
    preparingAccount: "Un attimo, stiamo preparando il Suo account...",
    verifyEmailCallBody: (email) =>
        `Inserisca il codice inviato a ${email}.\n\nNon dimentichi di controllare la posta indesiderata.`,
    verifyingPhone: "Verifica del numero di telefono",
    verifyingEmail: "Verifica dell'indirizzo e-mail",
    phoneVerified: "Telefono verificato",
    emailVerified: "Indirizzo e-mail verificato",
    verifyingPhoneWait: "Un attimo, stiamo verificando il Suo numero di telefono...",
    verifyingEmailWait: "Un attimo, stiamo verificando il Suo indirizzo e-mail...",
    phoneVerifiedSuccess: "Il Suo numero di telefono è stato verificato. Configuriamo ora il Suo account.",
    emailVerifiedSuccess: "Il Suo indirizzo e-mail è stato verificato. Configuriamo ora il Suo account.",
    verifyPhoneError: "Riprovi a verificare il Suo numero di telefono oppure contatti support@patient-watch.com",
    verifyEmailError: "Riprovi a verificare il Suo indirizzo e-mail oppure contatti support@patient-watch.com",
    verificationError: "Errore di verifica",
    tryAgain: "Riprovare",
    freemiumSignupTitle: "Crei il Suo account gratuito",
    freemiumSignupDescription:
        "Inviti pazienti, raccolga punteggi di esito e ne segua il recupero - pronto in pochi minuti, senza carta di credito.",
    freemiumSignupBenefit1: "Inviti pazienti e raccolga punteggi di esito subito",
    freemiumSignupBenefit2: "I promemoria automatici mantengono i pazienti coinvolti tra un consulto e l'altro",
    freemiumSignupBenefit3: "Segua l'evoluzione nel tempo con un cruscotto clinico chiaro",
    freemiumSignupCta: "Creare un account gratuito",
    freemiumSignupSubmitting: "Creazione dell'account…",
    freemiumSignupUpgradeHint: "Ha bisogno di un volume maggiore?",
    freemiumSignupSeePaidPlans: "Vedere gli altri piani",
    diaryInviteUnavailableTitle: "Questo invito non è disponibile",
    diaryInviteUnavailableCallout: "Nessun diario è stato avviato",
    diaryInviteUnavailableBody: "Non è possibile aggiungere un altro diario con il piano attuale.",
    diaryInviteUnavailableNextStep:
        "Contatti il Suo ambulatorio. Potrà invitarla di nuovo non appena avrà disponibilità.",
    diaryInviteOwnerUnresolvedBody: "Non è stato possibile avviare questo diario. Chieda un nuovo link di invito.",
    mfaEnrollTitle: "Configurare l'app di autenticazione",
    mfaEnrollDescription: "Scansioni questo codice QR, quindi inserisca il codice a sei cifre della Sua app.",
    mfaManualSetup: "Impossibile scansionare il codice QR?",
    mfaQrCodeAlt: "Codice QR di configurazione dell'app di autenticazione",
    mfaChallengeTitle: "Autenticazione a due fattori",
    mfaChallengeDescription: "Inserisca il codice a sei cifre della Sua app di autenticazione.",
    mfaAuthenticatorCode: "Codice di autenticazione",
    mfaVerifyCode: "Verificare il codice",
    mfaVerifying: "Verifica…",
    mfaLoading: "Caricamento…",
    mfaSettingsTitle: "Sicurezza dell'app di autenticazione",
    mfaSettingsDescription: "La Sua app di autenticazione è necessaria per gli accessi con privilegi.",
    mfaFactorActive: "App di autenticazione attiva",
    mfaReplaceFactor: "Sostituire l'app di autenticazione",
    mfaReplaceConfirm: "Eliminare questa app di autenticazione e configurarne una nuova ora?",
};
